/**
 * Formats a date string or Date object using Saudi Arabia (AST / UTC+3) timezone.
 *
 * @param {string | Date | number} date - The date to format
 * @param {Intl.DateTimeFormatOptions} [options] - Additional Intl options
 * @returns {string} Formatted date string or '-' if invalid
 */
export const formatDate = (date, options = {}) => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'Asia/Riyadh',
      ...options,
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

/**
 * Formats a date with time using Saudi Arabia (AST / UTC+3) timezone.
 *
 * @param {string | Date | number} date - The date to format
 * @param {Intl.DateTimeFormatOptions} [options] - Additional Intl options
 * @returns {string} Formatted date-time string or '-' if invalid
 */
export const formatDateTime = (date, options = {}) => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Riyadh',
      ...options,
    });
  } catch (error) {
    console.error('Error formatting date time:', error);
    return '-';
  }
};
